import styled from "styled-components";
import { Card } from "../HomeComponents/StyledComponents";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import client from "../../sanity";
import { urlFor } from "../../sanity";

import MyLoader from "./MyLoader";

const Container = styled.div`
  color: rgba(138, 94, 191, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .card_container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
`;

export default function CompanyFetch(props) {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
   
  useEffect(() => {
    const queries = {
      2023: `*[_type == "placement23"]{...}`,
      2024: `*[_type == "placement24"]{...}`,
      2025:`*[_type== "placement25"]{...}`,
      2026:`*[_type== "placement26"]{...}`,
      default: `*[_type == "placement"]{...}`,
    };

    const query = queries[props.year] || queries.default;

    client.fetch(query).then(data => {
      console.log(query);
      setCompanies(data);
    });
  }, [props]);

  const year = props.year;
  // console.log(year);
  const yearFilter = companies.filter(element => element.year == year);
  const branchFilter = yearFilter.filter(element => {
    if (props.branch === "all") {
      return true;
    } else {
      return element.eligible_branch.toLowerCase().includes(props.branch) || 
             element.eligible_branch.toLowerCase().includes("open for all") || 
             element.eligible_branch.toLowerCase().includes("open to all");
    }
  });

  const filteredCompanies = branchFilter.filter(val => {
    if (!props.query) return true;
    return val.company_name.toLowerCase().includes(props.query.toLowerCase()) || 
           val.eligible_branch.toLowerCase().includes(props.query.toLowerCase());
  }).sort((a, b) => a.company_name.toLowerCase().localeCompare(b.company_name.toLowerCase()));

  return (
    <Container>
      <h1>Recruiters</h1>
      <div className="card_container">
        {filteredCompanies.length === 0 ? (
          <MyLoader />
        ) : (
          filteredCompanies.map((comp, idx) => (
            <Card
              onClick={() => {
                navigate(`/${props.type}/${comp.company_name}/${props.year}`);
              }}
              key={idx}
            >
              <h5 style={{ textTransform: "uppercase", textAlign: "center", fontWeight: "800" }}>
                {comp.company_name}
              </h5>
              {comp.image && (
                <img style={{ width: "50%" }} src={urlFor(comp.image).url()} alt="" />
              )}
            </Card>
          ))
        )}
      </div>
    </Container>
  );
}
